import React, {useEffect, useState} from "react";
import {StoryblokComponent} from "@storyblok/react";
import {FacebookShareButton, WhatsappShareButton} from "react-share";
import {SmallSocialButton} from "@commons/ui/component/SocialNetwork";
import {useCurrentLocation} from "@commons/infra/helpers";
import {useIntl} from "react-intl";
import {Helmet} from "react-helmet";
import {title} from "@commons/shared";
import {useParams} from "react-router-dom";
import {RichText} from "@commons/infra/storyblok/richText";
import Breadcrumbs from "@commons/ui/component/Breadcrumbs";
import {PublicLinks} from "../../../../portal-latvia/src/utility/links";
import {BackgroundWave2} from "@commons/uinew/domaincomponent/svg";
import {CenteredTextualContentLayout} from "@commons/uinew/layout/CenteredTextualContentLayout";
import {HeadingPlaceholder, MultipleParagraphsPlaceholder} from "@commons/uinew/component/placeholder";
import {LatvianMetaLinksHelmet} from "@commons/infra/i18n/MetaLinksHelmet";
import {extractImageDimensions, useSbDataFetcher} from "@commons/infra/storyblok/helpers";
import {BookAVisitMiniCta} from "@commons/ui/page/public/storyblok/SpecificHealthIssueStoryblokPage";
import {AboutUsBanner} from "@commons/ui/page/public/promotion/AboutUsBanner";
import PromocodeGiveawayPopup from "@commons/ui/page/public/promotion/PromocodeGiveawayPopup";
import {useConfirmationModalControls} from "@commons/infra/component/ConfirmationModal";


let BlogPostStoryblokPage = () => {
    let {locale} = useIntl()
    let {blogPostSlug: slug} = useParams();
    let currentLocation = useCurrentLocation();
    let sbDataFetcher = useSbDataFetcher()
    let controls = useConfirmationModalControls()

    let [isLoading, setIsLoading] = useState(true)
    let [story, setStory] = useState()
    let [imgDimensions, setImgDimensions] = useState({})

    useEffect(() => {
        sbDataFetcher(`blog/posts/${slug}_lv`, `cdn/stories/blog-posts/${slug}`, {language: locale})
            .then((r) => {
                setStory(r)
                setImgDimensions(extractImageDimensions(r.content.Picture.filename))
                setIsLoading(false)
            })
    }, [])


    useEffect(() => {
        setIsLoading(!(story && story.content))
    }, [story])

    return <>
        {!isLoading && <Helmet>
            <title>{title(story.content.Heading)}</title>
            <meta name="description" content={story.content.MetaDescription}/>
            <meta http-equiv="content-language" content="lv"/>
        </Helmet>}
        <LatvianMetaLinksHelmet/>

        <PromocodeGiveawayPopup controls={controls}/>

        <CenteredTextualContentLayout containerClassName={"mt-2"}>
            <BackgroundWave2/>

            <Breadcrumbs className={'mb-2'}
                         items={[{title: 'Blogs', link: PublicLinks.storyblokBlog()}]}
                         currentPageTitle={"Bloga raksts"}/>

            {/*Heading*/}
            <div className={"pb-2 mb-2"}>
                <h1>
                    {isLoading && <HeadingPlaceholder/>}
                    {!isLoading && story.content.Heading}
                </h1>
                <BookAVisitMiniCta/>
            </div>

            {/*Picture*/}
            <div className={"mb-4"}>
                {isLoading && <div className="position-relative placeholder-wave">
                    <div className="card-img-top placeholder ratio ratio-16x9"></div>
                    <i className="ai-image position-absolute top-50 start-50 translate-middle fs-1"></i>
                </div>}
                {!isLoading && <img
                    src={story.content.Picture.filename}
                    className={"rounded-5"}
                    alt={story.content.Picture.alt || story.content.Picture.name}
                    width={imgDimensions.width}
                    height={imgDimensions.height}
                />}
            </div>

            {/*Content*/}
            <p className="pb-lg-2 mb-2 mb-lg-3">
                {isLoading && <MultipleParagraphsPlaceholder/>}
                {!isLoading && <RichText
                    content={story.content.Content}
                    headingInserter={(i) => {
                        if (i === 5) {
                            return <AboutUsBanner/>
                        }
                    }}
                />}
            </p>

            <div className="d-flex flex-wrap align-items-center justify-content-between mb-4">
                <div className="d-flex align-items-center"><span className="fs-sm me-2">Share post:</span>
                    <div className="d-flex">
                        <FacebookShareButton url={currentLocation.routerLocation}>
                            <SmallSocialButton network={"facebook"}/>
                        </FacebookShareButton>

                        <WhatsappShareButton url={currentLocation.routerLocation}>
                            <SmallSocialButton network={"whatsapp"}/>
                        </WhatsappShareButton>
                    </div>
                </div>
            </div>
        </CenteredTextualContentLayout>

        {!isLoading && story.content.Footer.map(blok => <StoryblokComponent blok={blok}/>)}

    </>
}

export default BlogPostStoryblokPage